import React from 'react';
import { H3, Link } from '../../primitives';
import Spacer from '../../helpers/Spacer';
import styled from '@emotion/styled';
import { mixins, colors } from '../../core/styles/theme/default';
import { rem } from 'polished';

const StyledTool = styled.article`
  flex-direction: column;
  display: flex;
  background: linear-gradient(110deg, #12385f 0%, #0d2844 100%);
  border-radius: ${rem(2)};
  padding: ${rem(32)};
  color: ${colors.white};
  min-height: ${rem(300)};
  cursor: pointer;

  ${mixins.responsiveStyles({
    height: { zero: 'auto', medium: '100%' },
  })}

  header {
    display: flex;
    align-items: flex-end;
  }

  ${({ theme }) => theme?.stylesExtension?.teaserTools?.tool}
`;

const StyledToolMain = styled.div`
  flex: 1;
  color: ${colors.nightBlue300};

  ${({ theme }) => theme?.stylesExtension?.teaserTools?.main}
`;

const StyledTitle = styled(H3)`
  color: ${colors.white};
  overflow-wrap: break-word;

  ${({ theme }) => theme?.stylesExtension?.teaserTools?.title}
`;

const StyledLink = styled(Link)`
  padding: ${rem(10)} 0;
  margin-bottom: ${rem(-10)};

  span {
    color: ${colors.white};
  }

  &,
  .m-richtext & {
    text-decoration: none;
  }
`;

const TeaserTools = (props: TeaserToolsProps) => {
  const { title, teaser, href, moreLinkText, externalUrl, trackClick } =
    props.data;

  return (
    <>
      <StyledTool
        className="item animate"
        onClick={(e) => {
          trackClick?.();

          if (!(e.target as HTMLElement).closest('a')) {
            e.currentTarget.querySelector('a')?.click();
          }
        }}
      >
        <header>
          <StyledTitle>{title}</StyledTitle>
        </header>
        <Spacer space="gamma" />
        <StyledToolMain>{teaser}</StyledToolMain>
        <Spacer space="alpha" />
        <footer>
          <StyledLink
            linkText={moreLinkText}
            link={{
              href,
              title: moreLinkText,
              ...(externalUrl && {
                target: '_blank',
                rel: 'noopener noreferrer',
              }),
            }}
            variant={externalUrl ? 'external' : 'internal'}
          />
        </footer>
      </StyledTool>
    </>
  );
};

export type TeaserToolsProps = {
  data: {
    title: string;
    teaser?: string;
    slug?: string;
    node_locale?: string;
    href: string;
    moreLinkText: string;
    externalUrl?: boolean;
    trackClick?: () => void;
  };
};

export default TeaserTools;
